<template>
	<div>
		<div class="input-wrapper" :class="{'input-wrapper-tooltip': tooltip, 'has-focus': has_focus || value.length > 0, 'has-error': error.length > 0}">
			<div class="input-label" :class="{'has-icon': icon}">
				{{ label }} {{ required ? "*" : "" }}
			</div>

			<textarea 
			class="input-element" 
			autocomplete="none"

			ref="input_element" 
			:class="{'has-icon': icon}"
			:value="value"
			:disabled="disabled"

			@input="$emit('input', $event.target.value)"
			@focus="has_focus = true" 
			@blur="() => { has_focus = false; validate(); }" 
			@keypress.enter="on_enter_pressed"></textarea>

			<i :class="['input-icon', 'fa', 'fa-fw', icon]" v-if="icon"></i>

			<div class="input-error">
				{{ error }}
			</div>
		</div>
		<div v-if="tooltip" class="input-tooltip" v-popover:tooltip.left="tooltip">
			<i class="fas fa-question-circle"></i>
		</div>
	</div>
</template>


<script>
	export default {
		name: "FormTextarea",
		
		props: {
			icon: {
				type: String,
				require: false,
			},
			label: {
				type: String,
				require: true,
			},
			tooltip: {
				type: String,
				require: false,
			},
			value: {
				type: String,
				require: false,
				default: "",
			},
			required: {
				type: Boolean,
				require: false,
				default: false,
			},
			disabled: {
				type: Boolean,
				require: false,
				default: false,
			}
		},

		data: function() {
			return {
				has_focus: false,
				error: "",
			}
		},

		watch: {
			value: function() {
				this.validate();
			}
		},

		methods: {
			validate: function() {
				if ((this.required !== undefined) && (this.required == true)) {
					if (this.$refs.input_element.value.length == 0) {
						this.error = "* " + this.label + " é obrigatório.";
						return;
					}
				}

				this.error = "";
			},

			on_enter_pressed: function() {
				/*this.$refs.input_element.blur();*/
				this.$emit("onenter", this.$refs.input_element.value);
			}
		}
	}
</script>


<style scoped>

.input-wrapper {
	position: relative;
	width: 100%;
	height: 90px;
	color: #666;
	margin-bottom: 10px;
	display: inline;
	float: left;
}

.input-wrapper-tooltip {
	width: calc(100% - 20px);
}

.input-label {
	position: absolute;
	width: 100%;
	height: 25px;
	line-height: 30px;
	top: 25px;
	color: #999;
	transition: all 0.2s linear;
}

.has-focus .input-label {
	top: 0;
	left: 0 !important;
	font-size: 12px;
	color: #666;
}

.has-error .input-label {
	color: red;
}





.input-element {
	position: absolute;
	top: 20px;
	width: 100%;
	border: none;
	border-bottom: 1px solid #aaa;
	height: 80px;
	line-height: 20px;
	padding-top: 8px;
	background: none;
	resize: none;
}

.has-error .input-element {
	border-bottom: 1px solid red;
}




.input-error {
	width: 100%;
	position: absolute;
	top: 60px;
	font-size: 12px;
	height: 25px;
	line-height: 35px;
}

.has-error .input-error {
	color: red;
}







.input-element.has-icon {
	padding-left: 40px;
}

.input-label.has-icon {
	left: 40px;
	width: calc(100% - 40px);
}

.input-icon {
	position: absolute;
	top: 18px;
	width: 40px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	color: #666;
}


.has-error .input-icon {
	color: red;
}
</style>